import React, { useState, useRef } from 'react'
import { callAPI } from 'helpers'
import { useHistory } from 'react-router-dom'

// Components
import CustomModal from 'components/CustomModal'
import ExamForm from './ExamForm'

export default ({ _course, _class }) => {
  const history = useHistory()
  const examFormRef = useRef()
  const [creating, setCreating] = useState()

  const _onExamCreate = async () => {
    const formData = examFormRef.current.getFormData()
    if (formData) {
      const { courseCode, title, description } = formData
      try {
        setCreating(true)
        const { result: newExam } = await callAPI({
          method: 'POST',
          url: '/exams',
          body: { courseCode, title, description }
        })
        setCreating(false)
        history.replace(`/exams/${newExam.classExamId}`)
      } catch (error) {
        console.error('Error while trying to add new exam.', error.message)
        setCreating(false)
      }
    }
  }

  return (
    <CustomModal visible
      cancelText='ย้อนกลับ'
      okText='เพิ่มแบบทดสอบ'
      okButtonProps={{
        loading: creating,
        icon: 'plus'
      }}
      onCancel={() => history.goBack()}
      onOk={_onExamCreate}>
      <ExamForm ref={examFormRef} courseCode={_course} />
    </CustomModal>
  )
}



// WEBPACK FOOTER //
// ./src/components/exams/ExamCreateModal.js